import React, { useState,useRef,useEffect } from "react";
import {
  Card,
  Box,
  Heading,
  Button,
  CardHeader,
  CardBody,
  CardFooter,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerCloseButton,
  DrawerBody,
  Grid,
  FormControl,
  FormLabel,
  Image,
  DrawerFooter,
  Select,
  Input,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Textarea,
  Spinner,
  Switch
} from "@chakra-ui/react";
import { Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import axios from "axios";



import { Cell, LedgerRow, RowActions, StatusMark } from "../../../components/ui";
import { API_URL } from "../../../Apis/config";

function EventCard({event, Update, Delete,eassignees,upEvent }) {

  // console.log(eassignees,"event card assignees");
  
  
  // console.log(preparedInitialAssignees);
  const [assignees, setAssignees] = useState([]);
  const [originalAssignees, setOriginalAssignees] = useState([]);
// const [prvAssiges,setPrvAssiges]=useState(false);
const[preparedInitialAssignees,setPreparedInitialAssignees]=useState([]);
const [isDeleteAlertOpenEvent, setIsDeleteAlertOpenEvent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isdisabled, setIsdisabled] = useState(false);
  const [reac,setReac]=useState(true);
  const {
    isOpen: isOpenEditEvent1,
    onOpen: onOpenEditEvent1,
    onClose: onCloseEditEvent1,
  } = useDisclosure();

  const {
    isOpen: isOpenEditEvent2,
    onOpen: onOpenEditEvent2,
    onClose: onCloseEditEvent2,
  } = useDisclosure();

  const {
    isOpen: isOpenModal2,
    onOpen: onOpenModal2,
    onClose: onCloseModal2,
  } = useDisclosure();
  const initialRef = useRef(null);
  const [formData, setFormData] = useState({});
  const finalRef = useRef(null);


useEffect(()=>{
  const preparedData=prepareAssignees(eassignees, event.assignees);
  setPreparedInitialAssignees(preparedData);
},[event,eassignees,setReac]);


useEffect(()=>{
  setAssignees(preparedInitialAssignees)
},[preparedInitialAssignees]);

useEffect(() => {
  
    setOriginalAssignees(preparedInitialAssignees);
    
  }, [preparedInitialAssignees]);
  
  const prepareAssignees=(eassignees, eventAssignees = [])=> {
     // If there are no event assignees, simply return the assignee without modification.
    //  console.log("data is being prepared");
    if (eventAssignees.length === 0) {
      return eassignees.map((assignee) => ({ ...assignee }));
    }

    return eassignees.map(assignee => {
      
      
      // Find the corresponding event assignee, if any.
      const eventAssignee = eventAssignees.find(ea => ea._id === assignee._id);
      
      // Modify the assignee only if a corresponding event assignee is found.
      if (eventAssignee) {
        return {
          ...assignee,
          // Safely assign 'assigned' value, defaulting to false if not present.
          assigned: eventAssignee.assigned ?? false,
          eamount: eventAssignee.eamount ?? 0
        };
      }
      
      // Return a copy if no corresponding event assignee is found.
      return { ...assignee };
    });
  }

  

  
  
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "image") {
      let imageD = e.target.files[0];
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: imageD,
      }));
    } else if (name === "eventDate") {
      // Reformat the date value to "dd/mm/yyyy"
      const [year, month, day] = value.split("-");
      const formattedDate = `${day}/${month}/${year}`;

      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: formattedDate,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }

    
  };

  

  const handleToggleChange = (index) => {
    const newAssignees = [...assignees];
    newAssignees[index] = { ...newAssignees[index], assigned: !newAssignees[index].assigned };
    setAssignees(newAssignees);
    
    


  };

  const handleAmountChange = (index,evalue) =>{
    const newAssignees = [...assignees];
    newAssignees[index] = { ...newAssignees[index], eamount: evalue };
    setAssignees(newAssignees);
    
  }

  const handleToggleClose = () => {
    // Reset to original assignees state
    // console.log(originalAssignees);
    setAssignees(originalAssignees);
  };

  

  const saveAssignees = async(eventId) => {
// console.log(eventId,"check",assignees);
//on to off 
//off to on



    await axios.post(`${API_URL}/event/assignees`, { eventId,assignees })
    .then((res)=>
    
      upEvent()
    ).catch((err)=>err);
     
      onCloseEditEvent2();

      
  };


  const onSubmitUpdate = async (formData, id) => {
    if (formData.image) {
      // setIsdisabled(true);
      // setPrvAssiges(!prvAssiges);
      //why these are used here
      let imageUrl = "";
      try {
        const imageData = new FormData();
        imageData.append("file", formData.image);
        imageData.append("upload_preset", "tekxwxfz"); // Replace with your Cloudinary unsigned upload preset

        const response = await axios.post(
          `https://api.cloudinary.com/v1_1/dzidj8k7j/auto/upload`,
          imageData
        );
        imageUrl = response.data.secure_url;
        Update({ ...formData, image: imageUrl }, id);

        
        onCloseEditEvent1();
        setFormData({});
        // setIsdisabled(false);
      } catch (error) {
        console.error(error);
        return;
      }
    } else {
      Update(formData, id);
      onCloseEditEvent1();
        setFormData({});
    }
  };

  // console.log(assignees);
  // console.log(originalAssignees,"original");
  return (
    <>
      <LedgerRow stripe={event.paymentStatus ? "paid" : "unpaid"}>
        <Cell full>
          <Text fontWeight={600}>{event.fname} {event.lname}</Text>
          <Text fontSize="sm" color="stone.500">{event.phone}</Text>
        </Cell>
        <Cell label="Event">{event.eventName ? event.eventName : "Special Event"}</Cell>
        <Cell label="Scheduled">{event.eventDate}<Text fontSize="sm" color="stone.500">{event.eventTime}</Text></Cell>
        <Cell label="Status"><Flex direction="column" align="flex-start" gap={1}><StatusMark status={event.eventStatus} /><StatusMark status={event.paymentStatus ? "Paid" : "Unpaid"} /></Flex></Cell>
        <Cell full>
          <RowActions>
            <Button variant="outline" size="sm" onClick={onOpenModal2}>View</Button>
            <Button variant="outline" size="sm" onClick={()=>{setReac(()=>!reac);onOpenEditEvent2()}}>Assign</Button>
            <Button as={Link} to={`/admin/usersDtails/${event.userId}`} variant="outline" size="sm">User</Button>
            <Button variant="outline" size="sm" onClick={onOpenEditEvent1}>Edit</Button>
            <Button variant="danger" size="sm" onClick={() => setIsDeleteAlertOpenEvent(true)}>Delete</Button>
          </RowActions>
        </Cell>
      </LedgerRow>

      <Drawer
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpenModal2}
        onClose={onCloseModal2}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
          >
            Event Details
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody pb={6}>
            <Grid
              templateColumns={{ base: "1fr", md: "1fr 1fr" }}
              gap={4}
            >
              <FormControl>
                <FormLabel>Full Name</FormLabel>
                <Box>{`${event.fname} ${event.lname ? event.lname : ""}`}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Mobile number</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.phone}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.email}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>Event Status</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.eventStatus}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>Date</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.eventDate}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>Time</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.eventTime}
                </Box>
              </FormControl>
              <FormControl>
                <FormLabel>Amount</FormLabel>
                <Box>{event.ammount}</Box>
              </FormControl>
              <FormControl>
                <FormLabel>Payment Status</FormLabel>
                <Box>
                  {event.paymentStatus ? (
                    <span style={{ color: "green" }}>Paid</span>
                  ) : (
                    <span style={{ color: "red" }}>Not Paid</span>
                  )}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>City</FormLabel>
                <Box>{event.city ? event.city : "Not recorded"}</Box>
              </FormControl>
              <FormControl>
                <FormLabel> Submitted Date</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.bookingDate}
                </Box>
              </FormControl>
              <FormControl
                width="100%"
              >
                <FormLabel>Expense</FormLabel>
                <Box name="fname">{event.expense}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Reference</FormLabel>
                <Box>{event.referedby ? event.referedby : "Not recorded"}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Occupation</FormLabel>
                <Box>{event.occupation ? event.occupation : "Not recorded"}</Box>
              </FormControl>


              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Event Venue</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="Event Venue"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >{`${event.address}, ${event.pincode}`}</Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Full Address</FormLabel>
                <Box
                  name="faddress"
                  ref={initialRef}
                  placeholder="Full Address"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >{`${event.faddress}, ${event.pincode}`}</Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Assignees</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.assignees ? event.assignees.map((assi)=>
                  
                  assi.assigned?<button style={{padding:"2px 8px",backgroundColor:"#FCEFC7",margin:"4px",borderRadius:"3px",fontWeight:600}}>{assi.name} - {assi.eamount??0}</button>:""
                  ) : "None"}
                  
                </Box>
              </FormControl>


              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Message</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.message ? event.message : "Not recorded"}
                </Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Author Message</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {event.authorMessage ? event.authorMessage : "Not recorded"}
                </Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
              >
                <FormLabel>Event Image</FormLabel>
                <Image
                  src={
                    event.image
                      ? event.image
                      : "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg"
                  }
                />
              </FormControl>
            </Grid>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Drawer
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpenEditEvent1}
        onClose={onCloseEditEvent1}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
          >
            Edit Event
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody pb={6}>
            <Grid
              templateColumns={{ base: "1fr", md: "1fr 1fr" }}
              gap={4}
            >
              <FormControl>
                <FormLabel>First name</FormLabel>
                <Input
                  name="fname"
                  ref={initialRef}
                  placeholder={event.fname}
                  onChange={handleInputChange}
                  value={formData.fname}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Last name</FormLabel>
                <Input
                  name="lname"
                  placeholder={event.lname}
                  onChange={handleInputChange}
                  value={formData.lname}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  name="email"
                  placeholder={event.email}
                  onChange={handleInputChange}
                  value={formData.email}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Event Status</FormLabel>
                <Select
                  name="eventStatus"
                  value={formData.eventStatus || event.eventStatus}
                  onChange={handleInputChange}
                >
                  <option value="Pending">Pending</option>
                  <option value="Completed">Completed</option>
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Date</FormLabel>
                <Input
                  type="date"
                  name="eventDate"
                  placeholder={event.eventDate}
                  onChange={handleInputChange}
                  // value={formData.eventDate}
                  min={new Date().toISOString().slice(0, 10)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Time</FormLabel>
                <Input
                  type="time"
                  name="eventTime"
                  placeholder={event.eventTime}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Payment</FormLabel>
                <Select
                  name="paymentStatus"
                  value={formData.paymentStatus || event.paymentStatus}
                  onChange={handleInputChange}
                  defaultValue={event.paymentStatus ? "paid" : "notPaid"}
                >
                  <option value={false}>Not Paid</option>
                  <option value={true}>Paid</option>
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Amount</FormLabel>
                <Input
                  placeholder={event.ammount}
                  name="ammount"
                  type="number"
                  onChange={handleInputChange}
                  value={formData.ammount}
                />
              </FormControl>
              <FormControl
                width="100%"
              >
                <FormLabel>Upload Image</FormLabel>
                {/* <Input
                  type="file"
                    placeholder="Image"
                    name="image"
                    onChange={handleInputChange}
                  /> */}
                <Input
                  type="file"
                  id="imageMobile"
                  name="image"
                  accept="image/*"
                  onChange={handleInputChange}
                  required
                />
              </FormControl>
              <FormControl>
                <FormLabel>City</FormLabel>
                <Input
                  placeholder={event.city}
                  name="city"
                  type="text"
                  onChange={handleInputChange}
                  value={formData.city}
                />
              </FormControl>

              <FormControl
                width="100%"
              >
                <FormLabel>Expense</FormLabel>
                <Input
                  name="expense"
                  type="number"
                  placeholder={event.expense}
                  onChange={handleInputChange}
                  value={formData.expense}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Reference</FormLabel>
                <Input
                  name="referedby"
                  defaultValue={event.referedby}
                  onChange={handleInputChange}
                  value={formData.referedby}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Occupation</FormLabel>
                <Input
                  name="occupation"
                  defaultValue={event.occupation}
                  onChange={handleInputChange}
                  value={formData.occupation}
                />
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Event Venue</FormLabel>
                <Textarea
                  name="address"
                  defaultValue={event.address}
                  onChange={handleInputChange}
                  value={formData.address}
                />
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Full Address</FormLabel>
                <Textarea
                  name="faddress"
                  defaultValue={event.faddress}
                  onChange={handleInputChange}
                  value={formData.faddress}
                />
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Author Message</FormLabel>
                <Textarea
                  rows={6}
                  defaultValue={event.authorMessage}
                  name="authorMessage"
                  onChange={handleInputChange}
                  value={formData.authorMessage}
                />
              </FormControl>
            </Grid>
          </DrawerBody>

          <DrawerFooter>
            <Button
              mr={3}
              disabled={isdisabled || isLoading}
              onClick={() => {
                setIsLoading(true); // Set isLoading to true when the button is clicked
                onSubmitUpdate(formData, event._id).finally(() =>
                  setIsLoading(false)
                ); // Reset isLoading to false after the update is complete or if there's an error
              }}
            >
              {isLoading ? <Spinner size="sm" color="white" /> : "Save"}
            </Button>
            <Button variant="ghost"
              onClick={onCloseEditEvent1}
            >
              Cancel
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>


      <Drawer
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpenEditEvent2}
        onClose={()=>{handleToggleClose();onCloseEditEvent2()}}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
          >
            Edit Event Assignee
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody pb={6}>
            

          {assignees.map((assignee,index) => (

        <FormControl key={assignee._id} display='flex' alignItems='center' paddingBottom={"10px"}>
          <FormLabel htmlFor={assignee._id} mb='0' width={"80%"}>
            {assignee.name}-{assignee.mobile}
          </FormLabel>
          
          <Switch 
            size={"md"} 
            id={assignee._id}
            isChecked={assignee.assigned}
            onChange={()=>handleToggleChange(index)}
          />

          <Input 
            type="number" 
            placeholder="Amount" 
            value={assignee.eamount || ''} 
            onChange={(e) => handleAmountChange(index, e.target.value)}
            marginLeft="10px"
            width="30%"
          />
          {/* {console.log(assignee,assignee.assigned,"checking assignees")} */}
        </FormControl>
      ))}


       </DrawerBody>
          <DrawerFooter>
            <Button
              mr={3}
              disabled={isdisabled || isLoading}
              onClick={() => {
                setIsLoading(true); // Set isLoading to true when the button is clicked
                saveAssignees(event._id).finally(() =>
                //assignee.assigned
                  setIsLoading(false)
                ); // Reset isLoading to false after the update is complete or if there's an error
              }}
            >
              {isLoading ? <Spinner size="sm" color="white" /> : "Save"}
            </Button>
            <Button variant="ghost"
              onClick={()=>{
                // setPrvAssiges(!prvAssiges);
                handleToggleClose();onCloseEditEvent2();}}
            >
              Cancel
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>

      <AlertDialog
        isOpen={isDeleteAlertOpenEvent}
        leastDestructiveRef={finalRef}
        onClose={() => setIsDeleteAlertOpenEvent(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Confirmation
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this Event?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button variant="ghost"
                ref={finalRef}
                onClick={() => setIsDeleteAlertOpenEvent(false)}
              >
                Cancel
              </Button>
              <Button variant="dangerSolid"
                onClick={() => {
                  setIsDeleteAlertOpenEvent(false);
                  Delete(event._id);
                }}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export default EventCard;
